// extracted by mini-css-extract-plugin
export default {"container":"Chat_container__Wb6GS"};